import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#0a1628" />
        </svg>
      </div>

      <div className="footer-body">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            {/* Logo — .footer-logo-circle is the white ring, .footer-logo-img is the mark (sized independently) */}
            <Link to="/" className="footer-logo">
              <span className="footer-logo-circle">
                <img src="/stratos-logo.png" alt="Stratos Standard" className="footer-logo-img" />
              </span>
            </Link>
            <p className="footer-tagline">
              Celebrating children who reach new heights, early.
            </p>
            <div className="footer-skies-badge">
              <span className="skies-logo">SKIES</span>
              <span>Supporting Kids in Early Success</span>
            </div>
          </div>

          {/* Links */}
          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services &amp; Pricing</Link></li>
              <li><Link to="/book">Book a Session</Link></li>
              <li><Link to="/blog">Blog &amp; Updates</Link></li>
              <li><Link to="/reviews">Parent Reviews</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Consultants</h4>
            <ul>
              <li><Link to="/become-consultant">Become a Consultant</Link></li>
              <li><Link to="/contact">Consultant Inquiries</Link></li>
            </ul>
            <h4 style={{ marginTop: '24px' }}>Legal</h4>
            <ul>
              <li><Link to="/contact">Privacy Policy</Link></li>
              <li><Link to="/contact">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Contact snippet */}
          <div className="footer-col">
            <h4>Get in Touch</h4>
            <address className="footer-contact">
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href="mailto:hello@stratosstandard.com">hello@stratosstandard.com</a>
              </p>
              {/* Phone hidden for now — restore when a real number is available
              <p>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.67 19.79 19.79 0 01.22 2.18 2 2 0 012.18 0h3.09a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.16 6.16l1.27-.63a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 15.72z"/></svg>
                <a href="tel:+15551234567">(555) 123-4567</a>
              </p>
              */}
            </address>
            <div className="footer-social">
              <a href="#!" aria-label="Facebook" className="social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
              </a>
              <a href="#!" aria-label="Instagram" className="social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="#!" aria-label="LinkedIn" className="social-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* E-E-A-T / YMYL safe-zone anchor: state plainly what we are and aren't. */}
        <p className="footer-disclaimer">
          Stratos Standard is an achievement recognition and registry service. It is not a
          medical, diagnostic, developmental-screening, or therapeutic service, and nothing
          on this site is medical or developmental advice. For any concern about your child's
          development, please consult your pediatrician or your state's early-intervention program.
        </p>

        <div className="footer-bottom">
          <p>&copy; {year} Stratos Standard. All rights reserved.</p>
          <p className="footer-tagline-bottom">Where Every Child's Achievement Reaches the Sky</p>
        </div>
      </div>
    </footer>
  );
}
